import React from 'react';
import { Layout } from '../components/layout';

const PAGE_TITLE = { fontFamily: 'Manrope, sans-serif', fontWeight: 800, fontSize: '22px', lineHeight: '28px', letterSpacing: '-0.4px', color: '#1A1D1A' } as const;
const TITLE = { fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '19px', lineHeight: '24px', letterSpacing: '-0.3px', color: '#1A1D1A' } as const;
const MUTED = { fontSize: '14px', lineHeight: '19px', color: '#818384' } as const;
const TEXT = { fontSize: '14px', lineHeight: '19px', color: '#1A1D1A' } as const;

// Текст страницы — от клиента (на нее ведет баннер «Что такое позиции?»)
const POSITIONS = [
  ['П2', 'Играете на выданном аккаунте', 'Входите в выданный аккаунт на своей консоли, скачиваете игру и играете прямо с него. Самый выгодный вариант.'],
  ['П3', 'Играете на своем аккаунте', 'Входите в выданный аккаунт, включаете общий доступ к консоли, скачиваете игру и запускаете ее уже со своего профиля — с вашими трофеями и сохранениями.'],
] as const;

const RULES = [
  'Запрещено передавать (или продавать) данные от аккаунта третьим лицам.',
  'Запрещено менять данные от аккаунта, логин или пароль.',
  'Запрещено заходить на аккаунт на другой консоли или устройстве — в браузере или на телефоне в приложении.',
  'Запрещено включать двухэтапную (или выключать, если она включена) аутентификацию на аккаунте.',
  'Запрещено играть не по своей позиции. Если купили П2 — необходимо соблюдать установленный порядок использования для П2. Если взяли П3, то необходимо соблюдать установленный порядок использования для П3.',
];

/** «Что такое позиции?» раздела «Шеринг». Назад — кнопкой Telegram, как на остальных экранах шеринга */
export const SharingPositionsPage: React.FC = () => (
  <Layout>
    <div className="px-4 pt-4 pb-6">
      <h1 className="mb-2" style={PAGE_TITLE}>Что такое позиции?</h1>
      <p style={MUTED}>
        Мы выдаем доступ к аккаунту, на котором уже куплена игра. Аккаунт остается у вас навсегда — играете комфортно и без вылетов.
      </p>

      <div className="mt-4 space-y-3">
        {POSITIONS.map(([badge, title, text]) => (
          <div key={badge} className="flex gap-3 rounded-2xl bg-white p-4">
            <span className="flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center text-white text-sm font-extrabold" style={{ background: '#3657F0', fontFamily: 'Manrope, sans-serif' }}>{badge}</span>
            <div>
              <h2 style={{ ...TITLE, fontSize: '15px', lineHeight: '20px' }}>{title}</h2>
              <p className="mt-1" style={MUTED}>{text}</p>
            </div>
          </div>
        ))}
      </div>

      <h2 className="mt-6 mb-3" style={TITLE}>Правила пользования</h2>
      <ol className="rounded-2xl bg-white p-4 space-y-3">
        {RULES.map((rule, i) => (
          <li key={i} className="flex gap-3">
            <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-[13px] font-bold" style={{ background: '#EBEEFE', color: '#3657F0', fontFamily: 'Manrope, sans-serif' }}>{i + 1}</span>
            <p style={TEXT}>{rule}</p>
          </li>
        ))}
      </ol>
      <p className="mt-4" style={{ ...TEXT, fontWeight: 700 }}>
        Нарушение любого из правил ведет к изъятию купленного аккаунта без возврата средств.
      </p>
    </div>
  </Layout>
);
